import Axios from 'axios'

const comfortPack = {
  getSensors() {
    return Axios.get(`api/v1/sensors`, {
      ignoreGlobalCatch: true,
    })
  },
  createSensor(sensor) {
    return Axios.post(`api/v1/sensors`, sensor, {
      ignoreGlobalCatch: true,
    })
  },
  editSensor(sensor) {
    return Axios.put(`api/v1/sensors/${sensor.id}`, { clientId: sensor.clientId, locationId: sensor.locationId }, {
      ignoreGlobalCatch: true,
    })
  },
  deleteSensor(sensorId) {
    return Axios.delete(`api/v1/sensors/${sensorId}`, {
      ignoreGlobalCatch: true,
    })
  }
}

export default comfortPack
